<template>
  <div class="index-content">
    <el-tabs v-model="statisticType" @tab-click="tabClick">
      <el-tab-pane label="客户线索" name="CUSTOM_CLUE">
        <div class="overview-box" style="margin-top: 10px">
          <div class="filter-box">
            <statistics-filter
                    @dateItem="dateItem"
                    @changeDuringTime="changeDuringTime"
                    @confirmMember="confirmMember"
                    ref="statisticFilter_CUSTOM_CLUE"
            ></statistics-filter>
            <span> <i
                    class="arsenal_icon arsenalshezhi"
                    style="color: #909399;cursor:pointer;"
                    @click="statisticaiDialogVisible = true"
            ></i></span>
          </div>

          <div
            class="statistical-data"
            style="margin-top: 10px; margin-bottom: 10px"
          >
            <div class="statistical-data-item">
              <div class="desc">新增线索数</div>
              <div class="content">
                {{customerLeads.count}}<span class="small-text" title="活跃率">全部:{{customerLeads.totalCount}}</span>
              </div>
            </div>
            <div class="statistical-data-item">
              <div class="desc">未分配线索数
              </div>
              <div class="content">{{customerLeads.unassignedCount}}</div>
            </div>
            <div class="statistical-data-item">
              <div class="desc">跟进中客户
               <!-- <i
                  class="arsenal_icon arsenalshezhi"
                  style="margin-left: 10px; color: #909399"
                  @click="genjinDialogVisible = true"
                ></i>-->
              </div>
              <div class="content">{{customerLeads.followingCount}}</div>
            </div>
            <div class="statistical-data-item">
              <div class="desc">成交客户
               <!-- <i
                  class="arsenal_icon arsenalshezhi"
                  style="margin-left: 10px; color: #909399"
                  @click="chengjiaoDialogVisible = true"
                ></i>-->
              </div>
              <div class="content" style="color: #67c23a">{{customerLeads.dealCount}}</div>
            </div>
            <div class="statistical-data-item">
              <div class="desc">丢单客户
               <!-- <i
                  class="arsenal_icon arsenalshezhi"
                  style="margin-left: 10px; color: #909399"
                  @click="diudanDialogVisible = true"
                ></i>-->
              </div>
              <div class="content" style="color: #f56c6c">{{customerLeads.lostCount}}</div>
            </div>
            <div class="statistical-data-item">
              <div class="desc">取消好友关系客户数</div>
              <div class="content" style="color: #f56c6c">{{customerLeads.unfriendCount}}</div>
            </div>
            <div class="statistical-data-item">
              <div class="desc">新增手机号码客户数</div>
              <div class="content">
                {{customerLeads.mobileCount}}<span class="small-text" title="活跃率"
                  >已加微信:{{customerLeads.mobileAddExRate}}%</span
                >
              </div>
            </div>
            <div class="statistical-data-item">
              <div class="desc">新增微信客户数</div>
              <div class="content">{{customerLeads.wxCount}}</div>
            </div>
            <div class="statistical-data-item">
              <div class="desc">新增企业微信客户数</div>
              <div class="content">{{customerLeads.ewxCount}}</div>
            </div>
            <div class="statistical-data-item">
              <div class="desc">总活跃客户</div>
              <div class="content">
                {{customerLeads.activeCount}}<span class="small-text" title="活跃率">{{customerLeads.activeRate}}%</span>
              </div>
            </div>
            <div class="statistical-data-item">
              <div class="desc">与员工沟通客户数</div>
              <div class="content" v-if="customerLeads.chatWithStaffCount">{{customerLeads.chatWithStaffCount}}</div>
              <div class="content" v-else>0</div>
            </div>
            <div class="statistical-data-item">
              <div class="desc">与机器人沟通客户数</div>
              <div class="content">{{customerLeads.chatWithBotCount}}</div>
            </div>
            <div class="statistical-data-item">
              <div class="desc">查看朋友圈客户数</div>
              <div class="content" v-if="customerLeads.viewMomentsCount">{{customerLeads.viewMomentsCount}}</div>
              <div class="content" v-else>0</div>
            </div>
            <div class="statistical-data-item">
              <div class="desc">查看智能名片客户数</div>
              <div class="content">{{customerLeads.viewBusinessCardCount}}</div>
            </div>
          </div>
          <div class="statistical-charts" style="height: 400px">
            <div class="statistical-charts-item">
              <div class="statistical-charts-header">
                <i class="el-icon-data-analysis"></i>
                线索运营分析
               <!-- <i
                  class="arsenal_icon arsenalshezhi"
                  style="margin-left: 10px; color: #909399"
                  @click="settingDialogVisible = true"
                ></i>-->
              </div>
              <div
                id="leadsOperatingChart"
                :style="{ width: '40vw', height: '300px' }"
              ></div>
            </div>
            <div class="statistical-charts-item">
              <div class="statistical-charts-header">
                <i class="el-icon-data-analysis"></i>
                线索来源分析
              </div>
              <div
                id="leadsSourcePieChart"
                :style="{ width: '40vw', height: '300px' }"
              ></div>
            </div>
          </div>
          <div class="statistical-charts-single">
            <div class="statistical-charts-single-header">
              <i class="el-icon-data-analysis"></i>
              新增客户线索
            </div>
            <div
              id="newLeadsChart"
              :style="{ width: 'calc(100vw - 200px)', height: '600px' }"
            ></div>
          </div>
          <div class="statistical-charts" style="height: 400px">
            <div class="statistical-charts-item">
              <div class="statistical-charts-header">
                <i class="el-icon-data-analysis"></i>
                热门标签
              </div>
              <wordcloud
                :data="hotLabelData"
                nameKey="name"
                valueKey="value"
                color="Accent"
                v-if="hotLabelData.length >0"
              >
              </wordcloud>
              <div v-else class="emptyData">暂无数据</div>
            </div>
            <div class="statistical-charts-item">
              <div class="statistical-charts-header">
                <i class="el-icon-data-analysis"></i>
                客户关心问题排行
              </div>
              <div
                id="hotIssues"
                :style="{ width: '40vw', height: '300px' }"
                v-if="customerLeads.askQuestionRankData&&customerLeads.askQuestionRankData.length>0"
              ></div>
              <div class="emptyData" v-else>暂无数据</div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="客户群" name="GROUP_CHAT">
        <div class="overview-box" style="margin-top: 10px">
          <statistics-filter
                  @dateItem="dateItem"
                  @changeDuringTime="changeDuringTime"
                  @confirmMember="confirmMember"
                  ref="statisticFilter_GROUP_CHAT"
                  :tabName="statisticType"
          ></statistics-filter>
          <div
            class="statistical-data"
            style="margin-top: 40px; margin-bottom: 20px"
          >
            <div class="statistical-data-item">
              <div class="desc">新增客户群数</div>
              <div class="content">
                {{customerLeads.count}}<span class="small-text" title="活跃率">全部:{{customerLeads.totalCount}}</span>
              </div>
            </div>
            <div class="statistical-data-item">
              <div class="desc">新增群成员数</div>
              <div class="content">
                <span v-if="customerLeads.memberCount">{{customerLeads.memberCount}}</span>
                <span v-else>0</span>
                <span class="small-text" title="活跃率">全部:{{customerLeads.memberTotalCount}}</span>
              </div>
            </div>
            <div class="statistical-data-item">
              <div class="desc">企微账号客户数</div>
              <div class="content">
                {{customerLeads.ewxMemberCount}}<span class="small-text" title="活跃率">{{customerLeads.ewxMemberRate}}%</span>
              </div>
            </div>
            <div class="statistical-data-item">
              <div class="desc">微信账号客户数</div>
              <div class="content">
                {{customerLeads.wxMemberCount}}<span class="small-text" title="活跃率">{{customerLeads.wxMemberRate}}%</span>
              </div>
            </div>
            <div class="statistical-data-item">
              <div class="desc">已加微信好友数</div>
              <div class="content" style="color: #67c23a">
                {{customerLeads.friendCount}}<span class="small-text" title="活跃率">{{customerLeads.friendRate}}%</span>
              </div>
            </div>
            <div class="statistical-data-item">
              <div class="desc">未加微信好友数</div>
              <div class="content" style="color: #f56c6c">
                {{customerLeads.unfriendCount}}<span class="small-text" title="活跃率">{{customerLeads.unfriendRate}}%</span>
              </div>
            </div>
            <div class="statistical-data-item">
              <div class="desc">退群客户数</div>
              <div class="content" style="color: #f56c6c">{{customerLeads.quitGroupCount}}</div>
            </div>
            <div class="statistical-data-item">
              <div class="desc">群成员活跃比例</div>
              <div class="content">{{customerLeads.activeRate}}%</div>
            </div>
          </div>
          <div class="statistical-charts-single">
            <div class="statistical-charts-single-header">
              <i class="el-icon-data-analysis"></i>
              新增客户群/新增客户群成员数
            </div>
            <div
              id="qunLineChart"
              :style="{ width: 'calc(100vw - 200px)', height: '400px' }"
            ></div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="活码" name="CONTACT_CODE">
        <div class="overview-box" style="margin-top: 10px">
          <statistics-filter
                  @dateItem="dateItem"
                  @changeDuringTime="changeDuringTime"
                  @confirmMember="confirmMember"
                  ref="statisticFilter_CONTACT_CODE"
          ></statistics-filter>
          <div
            class="statistical-data"
            style="margin-top: 40px; margin-bottom: 20px"
          >
            <div class="statistical-data-item">
              <div class="desc">新增活码数</div>
              <div class="content">
                {{customerLeads.count}}<span class="small-text" title="活跃率">全部:{{customerLeads.totalCount}}</span>
              </div>
            </div>
            <div class="statistical-data-item">
              <div class="desc">新增扫码客户数</div>
              <div class="content">{{customerLeads.clueScanCount}}</div>
            </div>
            <!--<div class="statistical-data-item">
              <div class="desc">新增扫码客户群数</div>
              <div class="content">{{customerLeads.groupScanCount}}</div>
            </div>-->
            <div class="statistical-data-item">
              <div class="desc">扫码加好友数</div>
              <div class="content">
                {{customerLeads.scanCount}}<span class="small-text">全部:{{customerLeads.scanTotalCount}}</span>
              </div>
            </div>
            <div class="statistical-data-item">
              <div class="desc">通过活码添加客户数</div>
              <div class="content">
                {{customerLeads.clueCountFromScan}}<span class="small-text">占比:{{customerLeads.clueRateFromScan}}%</span>
              </div>
            </div>
            <div class="statistical-data-item">
              <div class="desc">未使用活码数</div>
              <div class="content" style="color: #f56c6c">
                {{customerLeads.unusedCodeCount}}<span class="small-text">占比:{{customerLeads.unusedCodeRate}}%</span>
              </div>
            </div>
            <div class="statistical-data-item">
              <div class="desc">员工活码数</div>
              <div class="content" style="color: #67c23a">
                {{customerLeads.memberCodeCount}}<span class="small-text">占比:{{customerLeads.memberCodeRate}}%</span>
              </div>
            </div>
           <!-- <div class="statistical-data-item">
              <div class="desc">群活码数</div>
              <div class="content" style="color: #f56c6c">{{customerLeads.groupCodeCount}}</div>
            </div>-->
          </div>
          <div class="statistical-charts-single">
            <div class="statistical-charts-single-header">
              <i class="el-icon-data-analysis"></i>
              扫码客户数
            </div>
            <div
              id="huomaLineChart"
              :style="{ width: 'calc(100vw - 200px)', height: '400px' }"
            ></div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="群发任务" name="GROUP_SEND_TASK">
        <div class="overview-box" style="margin-top: 10px">
          <div class="filter-box">
            <statistics-filter
                    @dateItem="dateItem"
                    @changeDuringTime="changeDuringTime"
                    @confirmMember="confirmMember"
                    ref="statisticFilter_GROUP_SEND_TASK"
                    :tabName="statisticType"
            ></statistics-filter>
            <el-select
                    v-model="taskIds"
                    filterable
                    placeholder="请选择任务"
                    @change="taskIdsChange"
                    multiple
                    collapse-tags
                    size="small"
            >
              <el-option
                v-for="item in taskList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div
            class="statistical-data"
            style="margin-top: 40px; margin-bottom: 20px"
          >
            <div class="statistical-data-item">
              <div class="desc">新增任务</div>
              <div class="content">
                {{customerLeads.count}}<span class="small-text" title="活跃率">全部:{{customerLeads.totalCount}}</span>
              </div>
            </div>
            <div class="statistical-data-item">
              <div class="desc">未失效任务数</div>
              <div class="content">{{customerLeads.validTaskCount}}</div>
            </div>
            <div class="statistical-data-item">
              <div class="desc">已失效任务数</div>
              <div class="content">{{customerLeads.invalidTaskCount}}</div>
            </div>
            <div class="statistical-data-item">
              <div class="desc">触达客户数</div>
              <div class="content">{{customerLeads.reachedCount}}</div>
            </div>
            <div class="statistical-data-item">
              <div class="desc">
                活跃客户数
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="触达客户后，客户进行咨询，查看动作"
                  placement="top"
                >
                  <i class="el-icon-warning-outline"></i>
                </el-tooltip>
              </div>
              <div class="content">
                {{customerLeads.activeCount}}<span class="small-text">占比:{{customerLeads.activeRate}}%</span>
              </div>
            </div>
            <div class="statistical-data-item">
              <div class="desc">
                沉睡客户数
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="触达客户后无任何进一步行动，如：查看，咨询等动作"
                  placement="top"
                >
                  <i class="el-icon-warning-outline"></i>
                </el-tooltip>
              </div>
              <div class="content" style="color: #f56c6c">
                {{customerLeads.sleepyCount}}<span class="small-text">占比:{{customerLeads.sleepyRate}}%</span>
              </div>
            </div>
            <div class="statistical-data-item">
              <div class="desc">
                成交客户数
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="触达客户后，客户进行了购买"
                  placement="top"
                >
                  <i class="el-icon-warning-outline"></i>
                </el-tooltip>
              </div>
              <div class="content" style="color: #67c23a">
                {{customerLeads.dealCount}}<span class="small-text">占比:{{customerLeads.dealRate}}%</span>
              </div>
            </div>
            <div class="statistical-data-item">
              <div class="desc">
                任务排名
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="任务执行后活跃客户与购买客户占比排名"
                  placement="top"
                >
                  <i class="el-icon-warning-outline"></i>
                </el-tooltip>
              </div>
              <div class="content" style="color: #e6a23c">
                <span v-if="customerLeads.rank">{{customerLeads.rank}}</span>
                <span v-else>--</span>
              </div>
            </div>
          </div>
          <div class="statistical-charts-single">
            <div class="statistical-charts-single-header">
              <i class="el-icon-data-analysis"></i>
              任务排行Top10
            </div>
            <div
              id="taskRankingLineChart"
              :style="{ width: 'calc(100vw - 200px)', height: '400px' }"
              v-if="customerLeads.taskRankData&&customerLeads.taskRankData.length >0"
            ></div>
            <div v-else class="emptyData">暂无数据</div>
          </div>
          <div class="statistical-charts-single">
            <div class="statistical-charts-single-header">
              <i class="el-icon-data-analysis"></i>
              任务效果分析
            </div>
            <div
              id="taskLineChart"
              :style="{ width: 'calc(100vw - 200px)', height: '400px' }"
              v-if="customerLeads.taskEffectAnalysisData&&customerLeads.taskEffectAnalysisData.length > 0"
            ></div>
            <div v-else class="emptyData">暂无数据</div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="智能名片" name="BUSINESS_CARD">
        <div class="overview-box" style="margin-top: 10px">
          <div class="filter-box">
            <statistics-filter
                    @dateItem="dateItem"
                    @changeDuringTime="changeDuringTime"
                    @confirmMember="confirmMember"
                    ref="statisticFilter_BUSINESS_CARD"
            ></statistics-filter>
          </div>
          <div
            class="statistical-data"
            style="margin-top: 40px; margin-bottom: 20px"
          >
            <div class="statistical-data-item">
              <div class="desc">名片总数</div>
              <div class="content">
                {{customerLeads.totalCount}}<span class="small-text" title="名片活跃率"
                  >活跃率:{{customerLeads.activeRate}}%</span
                >
              </div>
            </div>
            <div class="statistical-data-item">
              <div class="desc">查看名片次数</div>
              <div class="content">
                {{customerLeads.viewCount}}<span class="small-text" title="名片总数"
                  >名片总数:{{customerLeads.totalCount}}</span
                >
              </div>
            </div>
            <div class="statistical-data-item">
              <div class="desc">查看名片客户数</div>
              <div class="content">{{customerLeads.viewCountOfClue}}</div>
            </div>
            <div class="statistical-data-item">
              <div class="desc">访客</div>
              <div class="content">
                {{customerLeads.viewCountOfVisitor}}<span class="small-text" title="名片总数"
                  >留资比例:{{customerLeads.keepRate}}%</span
                >
              </div>
            </div>
            <div class="statistical-data-item">
              <div class="desc">
                分享名片人数
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="查看名片后进行了分享操作并成功"
                  placement="top"
                >
                  <i class="el-icon-warning-outline"></i>
                </el-tooltip>
              </div>
              <div class="content">
                {{customerLeads.shareUserCount}}<span class="small-text">占比:{{customerLeads.shareRate}}%</span>
              </div>
            </div>
            <div class="statistical-data-item">
              <div class="desc">
                与机器人沟通人数
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="查看名片后与机器人进行了沟通"
                  placement="top"
                >
                  <i class="el-icon-warning-outline"></i>
                </el-tooltip>
              </div>
              <div class="content">
                {{customerLeads.chatWithBotCount}}<span class="small-text">占比:{{customerLeads.chatWithBotRate}}%</span>
              </div>
            </div>
            <div class="statistical-data-item">
              <div class="desc">
                沉睡名片数
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="没有任何人查看名片"
                  placement="top"
                >
                  <i class="el-icon-warning-outline"></i>
                </el-tooltip>
              </div>
              <div class="content" style="color: #f56c6c">
                {{customerLeads.sleepyCount}}<span class="small-text">占比:{{customerLeads.sleepyRate}}%</span>
              </div>
            </div>
          </div>
          <div class="statistical-charts-single">
            <div class="statistical-charts-single-header">
              <i class="el-icon-data-analysis"></i>
              任务效果分析
            </div>
            <div
              id="bCardLineChart"
              :style="{ width: 'calc(100vw - 200px)', height: '400px' }"
            ></div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <!--   运营分析统计设置 -->
    <el-dialog
      title="请设置统计维度"
      :visible.sync="settingDialogVisible"
      width="30%"
    >
      <div class="select-box">
          <div class="select-item">
              <div class="source-name"><i class="arsenal_icon arsenalkehu"></i>线索总数</div>
              <div class="target-name">
                  <el-select v-model="value" placeholder="请选择跟进状态">
                    <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
              </div>
          </div>
          <div class="select-item">
              <div class="source-name"><i class="arsenal_icon arsenalweixin1"></i>已加微信</div>
              <div class="target-name">
                  <el-select v-model="value" placeholder="请选择跟进状态">
                    <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
              </div>
          </div>
          <div class="select-item">
              <div class="source-name"><i class="arsenal_icon arsenalcheck-circle-solid"></i>成交</div>
              <div class="target-name">
                  <el-select v-model="value" placeholder="请选择跟进状态">
                    <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
              </div>
          </div>
          <div class="select-item">
              <div class="source-name"><i class="arsenal_icon arsenalretweet-solid"></i>复购</div>
              <div class="target-name">
                  <el-select v-model="value" placeholder="请选择跟进状态">
                    <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
              </div>
          </div>
          <div class="select-item">
              <div class="source-name"><i class="arsenal_icon arsenalbhjlink"></i>转介绍</div>
              <div class="target-name">
                  <el-select v-model="value" placeholder="请选择跟进状态">
                    <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
              </div>
          </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="settingDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="settingDialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="请设置统计维度"
      :visible.sync="genjinDialogVisible"
      width="30%"
    >
      <div class="select-box">
          <div class="select-item">
              <div class="source-name"><i class="arsenal_icon arsenalkehu"></i>跟进中</div>
              <div class="target-name">
                  <el-select v-model="value" placeholder="请选择跟进状态">
                    <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
              </div>
          </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="genjinDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="genjinDialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="请设置统计维度"
      :visible.sync="chengjiaoDialogVisible"
      width="30%"
    >
      <div class="select-box">
          <div class="select-item">
              <div class="source-name"><i class="arsenal_icon arsenalkehu"></i>成交</div>
              <div class="target-name">
                  <el-select v-model="value" placeholder="请选择跟进状态">
                    <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
              </div>
          </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="chengjiaoDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="chengjiaoDialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="请设置统计维度"
      :visible.sync="statisticaiDialogVisible"
      width="40%"
    >
      <el-form ref="statisticaiDimension" :model="statisticaiDimension" label-width="100px" class="statisticai-dimension">
        <el-form-item>
          <div class="source-name" slot="label"><i class="arsenal_icon arsenalgenjin"></i>跟进中</div>
          <div class="target-name">
            <el-select
                    v-model="statisticaiDimension.followingStatusIds"
                    placeholder="请选择跟进状态"
                    multiple
            >
              <el-option
                      v-for="item in statusList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
              </el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item>
          <div class="source-name" slot="label"><i class="arsenal_icon arsenalkehu"></i>丢单状态</div>
          <div class="target-name">
            <el-select v-model="statisticaiDimension.lostStatusIds"
                       placeholder="请选择跟进状态"
                       multiple
            >
              <el-option
                      v-for="item in statusList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
              </el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item>
          <div class="source-name" slot="label"><i class="arsenal_icon arsenalweixin1"></i>已加微信</div>
          <div class="target-name">
            <el-select v-model="statisticaiDimension.addWxStatusIds"
                       placeholder="请选择跟进状态"
                       multiple
            >
              <el-option
                      v-for="item in statusList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
              </el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item>
          <div class="source-name" slot="label"><i class="arsenal_icon arsenalcheck-circle-solid"></i>成交</div>
          <div class="target-name">
            <el-select v-model="statisticaiDimension.dealStatusIds"
                       placeholder="请选择跟进状态"
                       multiple
            >
              <el-option
                      v-for="item in statusList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
              </el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item>
          <div class="source-name" slot="label"><i class="arsenal_icon arsenalretweet-solid"></i>复购</div>
          <div class="target-name">
            <el-select v-model="statisticaiDimension.repurchaseStatusIds"
                       placeholder="请选择跟进状态"
                       multiple
            >
              <el-option
                      v-for="item in statusList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
              </el-option>
            </el-select>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="statisticaiDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmStatisticai"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import StatisticsFilter from "./components/statisticsFilter.vue";
import wordcloud from "vue-wordcloud";
export default {
  components: { StatisticsFilter, wordcloud },
  data() {
    return {
      statisticType: "CUSTOM_CLUE",
      hotLabelData: [],
      value: "",
      options: [],
      settingDialogVisible: false,
      genjinDialogVisible: false,
      chengjiaoDialogVisible: false,
      statisticaiDialogVisible: false,
      memberFilters:[],
      dataTime:'ALL',
      startTime:0,
      endTime:0,
      customerLeads:{},
      taskIds:[],
      taskPage:1,
      taskPageSize:20,
      taskList:[],
      statisticRef:'statisticFilter_CUSTOM_CLUE',
      statisticaiDimension:{
        followingStatusIds:[],
        lostStatusIds:[],
        addWxStatusIds:[],
        dealStatusIds:[],
        repurchaseStatusIds:[]
      },
      statusList:[],
    };
  },
  methods: {
    tabClick(value){
      console.log(value)
      this.statisticType=value.name
      this.dataTime='ALL'
      this.startTime=0
      this.endTime=0
      this.memberFilters=[]
      this.taskIds=[]
      this.getCustomerLeads()
      this.statisticRef='statisticFilter_'+this.statisticType
      this.$nextTick(()=>{
        if (this.$refs[this.statisticRef]){
          this.$refs[this.statisticRef].checkData=''
          this.$refs[this.statisticRef].selectTime=''
          this.$refs[this.statisticRef].checkMember=[]
          this.$refs[this.statisticRef].memberName=[]
        }
      })
    },
    taskIdsChange(){
      this.getCustomerLeads()
    },
    //获取线索相关统计配置
    getStatistic(){
      let url='/scrm-api//statistics/config/clue'
      this.$http.get(url).then(res=>{
        console.log('我是统计分析',res)
        if (res.status===200){
          if (res.data){
            this.statisticaiDimension = res.data
          }
        }
      })
    },
    confirmStatisticai(){
      this.statisticaiDialogVisible=false
      console.log(this.statisticaiDimension)
      let url='/scrm-api//statistics/config/clue'
      this.$http.post(url,this.statisticaiDimension).then(res=>{
        console.log(res)
        if (res.data){
          this.getCustomerLeads()
        }
      })

    },
    //获取跟进状态
    getStatusList() {
      this.$http.get(' /scrm-api/followup-status').then(res=>{
        console.log('获取跟进状态',res)
        if (res.status===200){
          this.statusList = res.data;
        }

      })
    },
    //获取客户线索数据
    getCustomerLeads(){
      /*this.taskIds=[]*/
     /* if (this.value){
        this.taskIds.push(this.value)
      }*/
      console.log(this.taskIds)
      let url =''
      if (this.statisticType==='CUSTOM_CLUE'){
        url='/scrm-api/statistics/custom-clue'
      }
      else if (this.statisticType==='GROUP_CHAT'){
        url ='/scrm-api/statistics/group-chat'
      }
      else if (this.statisticType==='CONTACT_CODE'){
        url ='/scrm-api/statistics/contact-code'
      }
      else if (this.statisticType==='GROUP_SEND_TASK'){
        url ='/scrm-api/statistics/group-send-task'
      }
      else if (this.statisticType==='BUSINESS_CARD'){
        url ='/scrm-api/statistics/business-card'
      }
      let postData={
        dateItem: this.dataTime,
        end: this.endTime,
        memberFilters: this.memberFilters,
        start: this.startTime,
        taskIds: this.taskIds,
        type: this.statisticType,
      }
      this.$http.post(url,postData).then(res=>{
        if (res.status===200){
          console.log('获取客户线索',res)
          this.customerLeads = res.data
          if (this.customerLeads.hotLabelData){
            this.hotLabelData=this.customerLeads.hotLabelData
          }
          if (this.statisticType==='CUSTOM_CLUE'){
            if (this.customerLeads.sourceAnalysisData&&this.customerLeads.sourceAnalysisData.length>0){
              this.drawLeadsSourcePieChart();
            }
            if (this.customerLeads.askQuestionRankData&&this.customerLeads.askQuestionRankData.length>0){
              this.drawHotIssues();
            }
            this.drawLeadsOperating();
            this.drawNewLeadsChart();
          }
          if (this.statisticType==='GROUP_CHAT'){
            this.drawQunLineChart();
          }

          if (this.statisticType==='CONTACT_CODE'){
            if (this.customerLeads.scanCountData&&this.customerLeads.scanCountData.length>0){
              this.drawHuomaLineChart();
            }
          }
          if (this.statisticType==='GROUP_SEND_TASK'){
            this.getTask()
            if (this.customerLeads.taskRankData&&this.customerLeads.taskRankData.length>0){
              this.drawTaskRankingLineChart();
            }
            if (this.customerLeads.taskEffectAnalysisData&&this.customerLeads.taskEffectAnalysisData.length >0){
              this.drawTaskLineChart();
            }
          }
          if (this.statisticType==='BUSINESS_CARD'){
            if (this.customerLeads.businessCardAnalysisData&&this.customerLeads.businessCardAnalysisData.length >0){
              this.drawBCardLineChart();
            }
          }
          this.$nextTick(()=>{
            if (this.$refs[this.statisticRef]){
              this.$refs[this.statisticRef].getMember()
            }
          })
        }
      })

    },
    //获取群发任务
    getTask(){
      let data = Object.assign({}, this.taskPage, {
        page: this.taskPage - 1
      })
      let url = '/scrm-api/group-send-message-task/page?page=' + data.page + '&size=' + this.taskPageSize
      this.$http.get(url).then(res => {
        console.log(res)
        if (res.status === 200) {
          this.taskList = res.data.content
          console.log(this.taskList)

        }
      })
    },
    dateItem(data){
      this.dataTime=data
      this.startTime=0
      this.endTime=0
      this.getCustomerLeads()
    },
    changeDuringTime(data,startTime,endTime){
      if (startTime===0){
        this.dataTime='ALL'
      }
      else {
        this.dataTime=data
      }
      this.startTime=startTime
      this.endTime=endTime
      this.$nextTick(()=>{
        this.$refs[this.statisticRef].checkData=''
      })
      this.getCustomerLeads()
    },
    confirmMember(member){
      console.log(member)
      this.memberFilters =member
      this.getCustomerLeads()
      /*此时获取的id是string，后端是int*/
    },
    wordClickHandler(name, value, vm) {
      console.log("wordClickHandler", name, value, vm);
    },
    drawFunnelChart() {
      var echarts = require("echarts");
      var myChart = echarts.init(document.getElementById("myChart"));
      myChart.setOption({
        title: {
          // text: '漏斗图',
          // subtext: '纯属虚构',
          // left: 'left',
          // top: 'bottom'
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c}%",
        },
        // toolbox: {
        //     orient: 'vertical',
        //     top: 'center',
        //     feature: {
        //         dataView: {readOnly: false},
        //         restore: {},
        //         saveAsImage: {}
        //     }
        // },
        legend: {
          orient: "vertical",
          left: "left",
          data: ["推广", "线索", "成交", "复购", "转介绍"],
        },

        series: [
          {
            name: "漏斗图",
            type: "funnel",
            width: "40%",
            height: "45%",
            left: "25%",
            top: "5%",
            // label: {
            //     position: 'left'
            // },
            label: {
              position: "inside",
              formatter: "{c}%",
              color: "#fff",
            },
            data: [
              { value: 60, name: "推广" },
              { value: 40, name: "线索" },
              { value: 10, name: "成交" },
            ],
          },
          {
            name: "金字塔",
            type: "funnel",
            width: "40%",
            height: "45%",
            left: "25%",
            top: "50%",
            sort: "ascending",
            label: {
              position: "left",
            },
            data: [
              { value: 30, name: "复购" },
              { value: 10, name: "成交" },
              { value: 50, name: "转介绍" },
            ],
          },
        ],
      });
    },
    drawLeadsOperating() {
      var echarts = require("echarts");
      var myChart = echarts.init(
        document.getElementById("leadsOperatingChart")
      );
      let data = this.customerLeads.operationAnalysisData
      let legendData = data.length > 0?data.map(item=>item.name):[]
      myChart.setOption({
        title: {
          // text: '漏斗图',
          // subtext: '纯属虚构',
          // left: 'left',
          // top: 'bottom'
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c}",
        },
        // toolbox: {
        //     orient: 'vertical',
        //     top: 'center',
        //     feature: {
        //         dataView: {readOnly: false},
        //         restore: {},
        //         saveAsImage: {}
        //     }
        // },
        legend: {
          orient: "vertical",
          left: "left",
          data: legendData,
        },

        series: [
          {
            name: "漏斗图",
            type: "funnel",
            width: "40%",
            height: "45%",
            left: "25%",
            top: "15%",
            label: {
              position: "inside",
              formatter: "{c}",
              color: "#fff"
            },
            data: data,
          },
         /* {
            name: "金字塔",
            type: "funnel",
            width: "40%",
            height: "45%",
            left: "25%",
            top: "50%",
            sort: "ascending",
            label: {
              position: "left",
            },
            data:data,
          },*/
        ],
      });
    },
    // 新增客户线索柱状图
    drawNewLeadsChart() {
      var echarts = require("echarts");
      var myChart = echarts.init(document.getElementById("newLeadsChart"));
      let data = this.customerLeads.newClueSourceData
      let chartData=this.handleChartData(data,'CUSTOM_CLUE')
      console.log(chartData)
      myChart.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        legend: {
          data:chartData.titleData
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: chartData.timeData,
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: chartData.seriesData,
      });
    },
    drawLeadsSourcePieChart() {
      var echarts = require("echarts");
      var myChart = echarts.init(
        document.getElementById("leadsSourcePieChart")
      );
      let date = this.customerLeads.sourceAnalysisData
      let color = []
      for (let i=0;i<date.length;i++){
        if (date[i].name==='手动录入'){
          color.push('#5470c6')
        }
        if (date[i].name==='API推送'){
          color.push('#91cc75')
        }
        if (date[i].name==='员工活码'){
          color.push('#fac858')
        }
        if (date[i].name==='机器人自动提交'){
          color.push('#ee6666')
        }
        if (date[i].name==='智能名片'){
          color.push('#73c0de')
        }
        if (date[i].name==='企业微信好友'){
          color.push('#3ba272')
        }
        if (date[i].name==='自定义表单'){
          color.push('#fc8452')
        }
        if (date[i].name==='EXCEL批量导入'){
          color.push('#9a60b4')
        }
      }
      myChart.setOption({
        //     title: {
        //     text: '某站点用户访问来源',
        //     subtext: '纯属虚构',
        //     left: 'center'
        // },
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          left: "left",
        },
        color:color,
        series: [
          {
            name: "访问来源",
            type: "pie",
            radius: "50%",
            data: date,
            top:'-20%',
            left:'10%',
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      });
    },
    drawPieChart() {
      var echarts = require("echarts");
      var myChart = echarts.init(document.getElementById("pieChart"));
      myChart.setOption({
        //     title: {
        //     text: '某站点用户访问来源',
        //     subtext: '纯属虚构',
        //     left: 'center'
        // },
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          left: "left",
        },
        series: [
          {
            name: "访问来源",
            type: "pie",
            radius: "50%",
            data: [
              { value: 1048, name: "朋友圈文章" },
              { value: 735, name: "直接访问" },
              { value: 580, name: "官网机器人" },
              { value: 484, name: "智能名片" },
              { value: 300, name: "智能名片机器人" },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      });
    },
    // 热门问题图表
    drawHotIssues() {
      var echarts = require("echarts");
      var labelRight = {
        position: "right",
      };
      var labelLeft = {
        position: "left",
      };
      var myChart = echarts.init(document.getElementById("hotIssues"));
      let data=this.customerLeads.askQuestionRankData
      let seriesData =data.length>0?data.map(item=>item.value):[]
      let titleData = data.length >0?data.map(item=>item.name):[]
      console.log(seriesData)
      console.log(titleData)
      myChart.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        grid: {
          top: 80,
          bottom: 30,
        },
        xAxis: {
          type: "value",
          position: "top",
          splitLine: {
            lineStyle: {
              type: "dashed",
            },
          },
        },
        yAxis: {
          type: "category",
          axisLine: { show: false },
          axisLabel: { show: false },
          axisTick: { show: false },
          splitLine: { show: false },
          data: titleData,
        },
        series: [
          {
            name: "",
            type: "bar",
            stack: "总量",
            barMinHeight: 30,
            label: {
              show: true,
              formatter: "{b}",
            },
            data: seriesData,
          },
        ],
      });
    },
    // 新增群和群客户折线图
    drawQunLineChart() {
      var echarts = require("echarts");
      var myChart = echarts.init(document.getElementById("qunLineChart"));
      let data = this.customerLeads.groupChatAndMemberData
      let chartData=this.handleChartData(data,'GROUP_CHAT')

      console.log(chartData)
      myChart.setOption({
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["客户群", "群成员"],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          data: chartData.timeData,
        },
        yAxis: {
          type: "value",
        },
        series:chartData.seriesData,
      });
    },
    // 新增扫码客户数
    drawHuomaLineChart() {
      var echarts = require("echarts");
      var myChart = echarts.init(document.getElementById("huomaLineChart"));
      let data = this.customerLeads.scanCountData
      let chartData =this.handleChartData(data,'CONTACT_CODE')
      console.log(chartData)
      myChart.setOption({
        legend:{
          data: chartData.titleData
        },
        tooltip: {},
       /* dataset: {
          source: [
            ["product", "扫码客户数", "活码数"],
            ["周一", 433, 7],
            ["周二", 831, 73],
            ["周三", 864, 65],
            ["周四", 724, 53],
            ["周五", 724, 53],
            ["周六", 724, 53],
            ["周日", 724, 53],
          ],
        },
        xAxis: { type: "category" },
        yAxis: {},
        // Declare several bar series, each will be mapped
        // to a column of dataset.source by default.
        series: [{ type: "bar" }, { type: "bar" }],*/
        xAxis: {
          type: "category",
          data: chartData.timeData,
        },
        yAxis: {
          type: "value",
        },

        series:chartData.seriesData,
      });
    },
    // 任务效果分析
    drawTaskLineChart() {
      var echarts = require("echarts");
      var myChart = echarts.init(document.getElementById("taskLineChart"));
      let data = this.customerLeads.taskEffectAnalysisData
      let chartData = this.handleChartData(data,'GROUP_SEND_TASK')
      console.log(chartData)
      myChart.setOption({
        legend: {
          data: chartData.titleData
        },
        tooltip: {},
        xAxis:{
          type: "category",
          data: chartData.timeData,
        },

        yAxis: {
          type: "value",
        },

        series:chartData.seriesData,
      });
    },
    // 任务排行分析
    drawTaskRankingLineChart() {
      var echarts = require("echarts");
      var myChart = echarts.init(
        document.getElementById("taskRankingLineChart")
      );
      let data=this.customerLeads.taskRankData?this.customerLeads.taskRankData:[]
      let chartData=this.handleChartData(data,'GROUP_SEND_TASK')
      console.log(chartData)
      myChart.setOption({
        title: {
          text: "",
          subtext: "",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          data: chartData.titleData,
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          boundaryGap: [0, 0.01],
        },
        yAxis: {
          type: "category",
          data: chartData.titleData,
        },
        series:chartData.seriesData,
      });
    },
    // 名片展现效果分析
    drawBCardLineChart() {
      var echarts = require("echarts");
      var myChart = echarts.init(document.getElementById("bCardLineChart"));
      let data=this.customerLeads.businessCardAnalysisData
      let chartData = this.handleChartData(data,'BUSINESS_CARD')
      console.log(chartData)
      myChart.setOption({
        legend: {
          data: chartData.titleData,
        },
        tooltip: {},
       /* dataset: {
          source: [
            ["product", "展现次数", "客户数", "访客"],
            ["周一", 433, 70, 50],
            ["周二", 831, 73, 50],
            ["周三", 864, 65, 50],
            ["周四", 744, 53, 50],
            ["周五", 724, 53, 50],
            ["周六", 724, 53, 50],
            ["周日", 724, 53, 50],
          ],
        },
        xAxis: { type: "category" },
        yAxis: {},
        // Declare several bar series, each will be mapped
        // to a column of dataset.source by default.
        series: [{ type: "bar" }, { type: "bar" }, { type: "bar" }],*/
        xAxis: [{
          type: "category",
          data: chartData.timeData,
        }],
        yAxis: {
          type: "value",
        },
        series:chartData.seriesData,
      });
    },
    //公共方法处理图表数据
    handleChartData(data,type){
      let titleData =data.length>0? data[0].values.map(items=>{
        return items.name
      }):[]
      let timeData = data.length>0?data.map(item=>item.showTime):[]
     let  series=data.length>0?data.map(item=>{
        return item.values.map(items=>{
          return items.value
        })
      }):[]
      var newArray =series.length>0? series[0].map(function(col, i) {
        return series.map(function(row) {
          return row[i];
        })
      }):[]
      let seriesData =newArray.length>0? newArray.map((item,index)=>{
        let info={}
        if (type==='CUSTOM_CLUE'){
          info ={
            name:titleData[index] ,
            type: "bar",
            stack: "广告",
            emphasis: {
              focus: "series",
            },
            data: newArray[index],
          }
        }
        else if (type==='BUSINESS_CARD'||type==='GROUP_SEND_TASK'||type==='CONTACT_CODE'){
          info={
            data: newArray[index],
            type: 'bar',
            name:titleData[index]
          }
        }
         else{
          info={
            name: titleData[index],
            type: "line",
            stack: "总量",
            data: newArray[index],
          }
        }

        return info
      }):[]
      let returnData={
        seriesData:seriesData,
        timeData:timeData,
        titleData:titleData
      }
      return returnData
    }
  },
  mounted() {
    // this.drawFunnelChart();
    // this.drawPieChart();

    this.getCustomerLeads()
    this.getStatusList()
    this.getStatistic()
  },
};
</script>

<style lang="less">
@import url("../../assets/less/index/index.less");
</style>